import { Typography, TypographyProps } from "@mui/material";

export const P: React.FC<TypographyProps<"p">> = (props) => (
  <Typography component="p" variant="mBody" marginBottom="8px" {...props} />
);

export const Ps: React.FC<TypographyProps<"p">> = (props) => (
  <Typography component="p" variant="sBody" marginBottom="8px" {...props} />
);

export const H1: React.FC<TypographyProps<"h1">> = (props) => (
  <Typography
    component="h1"
    variant="xxlHeading"
    marginBottom="8px"
    {...props}
  />
);
